import { format } from 'date-fns';

export const formatDate = (date: string, dateFormat = 'MM/dd/yyyy') => format(new Date(date), dateFormat);
export const formatDateDetailed = (date: string) => format(new Date(date), 'MM/dd/yyyy - hh:mm');
export const getCurrentTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const removeTime = (date = new Date()) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
export const formatDateFull = (date: string) => format(new Date(date), 'MMM d, yyyy HH:mm');

export const isDateWithin = (startDateStr: string, endDateStr: string) => {
  if (!startDateStr || !endDateStr) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  return startDate <= today && today <= endDate;
};

export const getUTCDateOnly = (date: Date): Date => {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
};

export const normalizeUTCDateToLocal = (date: Date | null): Date | null => {
  if (!date) return null;
  const y = date.getUTCFullYear();
  const m = date.getUTCMonth();
  const d = date.getUTCDate();
  return new Date(y, m, d);
};

export const parseLocalDate = (iso: string | null): Date | null => {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d); // місяці в JS починаються з 0
};

export const formatDateToLocalIso = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0'); // місяць з 0
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
